import React, {Fragment} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {Autocomplete, CircularProgress, TextField} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {RequestErrorModal} from 'presentation/pages/private/refund/components';
import {useGetStates} from '../../../../hooks/useGetStates';
import {StateAutoCompleteProps} from './types';

const {chooseUF} = translations['pt-br'].privateFlow.refund.receiptRegistrationPage.providerData;

const {loading: loadingText, notFound: notFoundText} = translations['pt-br'].privateFlow.refund;

const {requiredField} = translations['pt-br'].commons;

export const StateAutoComplete = ({
	name,
	clearDependentFieldWhenChange,
	error,
}: StateAutoCompleteProps) => {
	const {control, resetField, clearErrors} = useFormContext();
	const {loadingList, options, open, handleClose, handleOpen, isError, handleRefresh} =
		useGetStates();

	return (
		<Fragment>
			<Controller
				control={control}
				name={name}
				render={({field: {value, onChange}, fieldState: {invalid}}) => (
					<Autocomplete
						open={open}
						onOpen={handleOpen}
						onClose={handleClose}
						onChange={(_event, selectedOptions) => {
							onChange(selectedOptions);
							if (clearDependentFieldWhenChange) {
								resetField(clearDependentFieldWhenChange);
							}
							clearErrors(name);
						}}
						value={value?.code ? value : null}
						isOptionEqualToValue={(option, valueOption) =>
							option?.code && option?.code === valueOption?.code
						}
						getOptionLabel={option => (option ? formatText(option.state) : '')}
						options={options ?? []}
						loading={loadingList}
						loadingText={loadingText}
						noOptionsText={notFoundText}
						renderInput={params => (
							<TextField
								{...params}
								error={invalid || !!error}
								placeholder={chooseUF}
								label={chooseUF}
								slotProps={{
									input: {
										...params?.InputProps,
										endAdornment: (
											<Fragment>
												{loadingList ? (
													<CircularProgress color="inherit" size={20} />
												) : null}
												{params?.InputProps?.endAdornment}
											</Fragment>
										),
									},
								}}
								helperText={invalid ? requiredField : null}
							/>
						)}
					/>
				)}
			/>
			<RequestErrorModal open={isError} setOpen={handleRefresh} />
		</Fragment>
	);
};
